// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switcher-button[data-v-7067f249]{background:transparent;border:none;box-shadow:none;width:40px;align-items:center;display:inline-flex;margin:12px 0}.dropdown-menu[data-v-7067f249]{border:1px solid!important;border-radius:5px!important;position:absolute;padding:4px!important;z-index:50;display:inline-block;width:40px;min-width:auto;left:-25px;top:38px}.dropdown-menu img[data-v-7067f249]{width:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
